export default class SliderManager {
    constructor(Swiper) {
        this.Swiper = Swiper;
        this.touchDevice = "ontouchstart" in document.documentElement;
    }

    addSlider(customSlider, parameters = {}) {
        return new this.Swiper.Swiper(
            customSlider.querySelector('[name="slider-container"]'),
            this._getParameters(customSlider, parameters)
        );
    }

    initializeSliderClick(sliderElement, sliderThumbDomElement) {
        sliderThumbDomElement.querySelectorAll('[name="slider"]').forEach((slider) => {
            slider.addEventListener("click", (event) => {
                sliderElement.slideTo(event.currentTarget.getAttribute('num'));
            });
        });
    }

    _getParameters(customSlider, parametersTmp) {
        parametersTmp = this._checkParameters(parametersTmp);
        let parameters = {
            modules: [this.Swiper.Navigation, this.Swiper.Pagination, this.Swiper.Thumbs, this.Swiper.FreeMode, this.Swiper.Keyboard],
            slidesPerView: parametersTmp.slidesPerView,
            observer: true,
            observeParents: true,
            parallax: true,
            centeredSlides: parametersTmp.centeredSlides,
            centeredSlidesBounds: true,
            spaceBetween: 10,
            initialSlide: parametersTmp.initialSlide,
            breakpoints: parametersTmp.breakpoints,
            watchOverflow: true,
            on: {
                slideChangeTransitionEnd: function () {
                    const event = new CustomEvent("swiperSlideChanged", {
                        detail: this.activeIndex
                    });
                    document.dispatchEvent(event);
                }
            }
        };

        if (this.Swiper.Lazy) {
            parameters.modules.push(this.Swiper.Lazy);
        }

        let modules = this._getModules(customSlider, parametersTmp);
        return {...parameters, ...modules};
    }

    _checkParameters(parametersTmp) {
        if (typeof parametersTmp != 'object') return parametersTmp;
        if (!('slidesPerView' in parametersTmp)) {
            parametersTmp.slidesPerView = 1;
        }
        if (!('centeredSlides' in parametersTmp)) {
            parametersTmp.centeredSlides = false;
        }
        if (!('initialSlide' in parametersTmp)) {
            parametersTmp.initialSlide = 0;
        }
        if (!('breakpoints' in parametersTmp)) {
            parametersTmp.breakpoints = {};
        }
        return parametersTmp;
    }

    _getModules(customSlider, parameters) {
        let modules = {
            lazy: {
                loadPrevNext: true,
                enabled: true
            },
            keyboard: {
                enabled: true,
                onlyInViewport: false,
            }
        };

        if (parameters.navigation) {
            modules.navigation = {
                nextEl: customSlider.querySelector('[name="button-next"]'),
                prevEl: customSlider.querySelector('[name="button-prev"]'),
                clickable: true
            };
        } else {
            let next = customSlider.querySelector('[name="button-next"]');
            if (next) {
                next.remove();
            }
            let prev = customSlider.querySelector('[name="button-prev"]');
            if (prev) {
                prev.remove();
            }
        }

        if (parameters.pagination) {
            if (parameters.bullets) {
                modules.pagination = {
                    el: customSlider.querySelector('[name="pagination"]'),
                    dynamicBullets: true,
                    dynamicMainBullets: 1
                };
            } else {
                modules.pagination = {
                    el: customSlider.querySelector('[name="pagination"]'),
                    type: "fraction"
                };
            }
        } else {
            let pagination = customSlider.querySelector('[name="pagination"]');
            if (pagination) {
                pagination.remove();
            }
        }

        if (parameters.thumbs) {
            modules.thumbs = {
                swiper: parameters.thumbs
            };
        }

        if (parameters.isThumb) {
            modules.watchSlidesVisibility = true;
            modules.watchSlidesProgress = true;
        }

        return modules;
    }
}
